import React from "react";

import {
	faArrowDownLeftAndArrowUpRightToCenter,
	faArrowUpRightAndArrowDownLeftFromCenter,
	faSparkles,
	faTriangleExclamation,
	faXmark,
} from "@fortawesome/pro-solid-svg-icons";

import { ButtonIcon, Icon, PageBanner } from "@performyard/py-components";

type HeaderProps = {
	isRetryDisabled: boolean;
	onExpand: () => void;
	onDismiss: () => void;
	isExpand: boolean;
};

export const Header = ({ isRetryDisabled, onExpand, onDismiss, isExpand = false }: HeaderProps): React.ReactElement => (
	<div>
		<div className="flex items-center justify-between py-1">
			<div className="flex items-center space-x-2">
				<Icon icon={faSparkles} color="neutral-9" size={16} />
				<span className="font-sans text-paragraph-2 font-normal leading-6 text-neutral-9">PerformYard</span>
			</div>
			<div className="flex items-center space-x-2">
				<ButtonIcon
					icon={isExpand ? faArrowDownLeftAndArrowUpRightToCenter : faArrowUpRightAndArrowDownLeftFromCenter}
					onClick={onExpand}
					variant="ghost"
					color="neutral"
					shade={5}
					size={24}
					data-testid="expand-header-button"
					aria-label="Expand"
				/>
				{!isExpand && (
					<>
						<div className="mx-2 h-6 w-px bg-gray-300" />
						<ButtonIcon
							icon={faXmark}
							onClick={onDismiss}
							variant="ghost"
							color="neutral"
							shade={5}
							size={24}
							data-testid="dismiss-header-button"
							aria-label="Dismiss"
						/>
					</>
				)}
			</div>
		</div>
		{isRetryDisabled && (
			<div className="py-2">
				<PageBanner
					size="large"
					color="red"
					icon={faTriangleExclamation}
					mainTitle=""
					subTitle="You have reached the retry limit of 25. Please choose from list below or start a new session to try again."
				/>
			</div>
		)}
	</div>
);
